module.exports = __webpack_public_path__ + "img/heart-null.fe4b75f1.svg";